import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  useTheme,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  imageSrc: string;
  imageName: string;
};

const ImageViewerDialog = ({ open, setOpen, imageSrc, imageName }: Props) => {
  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      maxWidth={false}
      fullWidth
      PaperProps={{
        style: {
          width: "800px",
          padding: "16px",
          backgroundColor: theme.palette.background.default,
          boxShadow: "none",
          paddingBottom: "8px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "16px",
          paddingBottom: 1,
          paddingLeft: "8px",
          paddingRight: 0,
          paddingTop: 0,
        }}
      >
        <b>{imageName}</b>
        <Button
          onClick={handleClose}
          sx={{ minWidth: "auto", fontSize: "20px" }}
        >
          ×
        </Button>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
          borderBottom: 0,
        }}
      >
        <img
          src={imageSrc}
          alt={imageName}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            borderRadius: "4px",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageViewerDialog;
